const users = [
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('@/views/users/UsersList.vue'),
    meta: {
      pageTitle: 'Usuários',
      breadcrumb: [
        {
          text: 'Usuários',
          active: true,
        },
      ],
    },
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: () => import('@/views/users/account-setting/AccountSetting'),
    meta: {
      pageTitle: 'Usuários',
      breadcrumb: [
        {
          text: 'Usuários',
          active: true,
        },
      ],
    },
  },
]

export default users
